var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("sidebar.billinghistory")) + "\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("BaseTable", {
            staticClass: "custom-table",
            attrs: { pagination: _vm.pagination, tableClass: "table-bordered" },
            on: { onPageChange: _vm.handlePageChange },
            scopedSlots: _vm._u([
              {
                key: "thead",
                fn: function() {
                  return [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("apps.billing.label.detail")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "400px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("apps.payment.label.ordernumber"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            staticStyle: { width: "200px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("apps.billing.label.paiddate"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "text-right",
                            staticStyle: { width: "200px" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("apps.billing.label.payamount"))
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "tbody",
                fn: function() {
                  return [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _vm.empty
                            ? _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "5" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("message.notfounddata")) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.transformData, function(item, index) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.description) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.chargeId) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getDateCustom(item.paidAt, {
                                      format: "YYYY-MM-DD H:m:s"
                                    })
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getCurrencyWithNumber(
                                      _vm.numberel(item.paidAmount, "0,0.00")
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8841e3d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8841e3d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/billing/history/Index.vue
// module id = null
// module chunks = 